import { Button, Card, Form } from "antd";
import React, { useState } from "react";
import BackButton from "../../../../components/common/BackButton";
import FormAction from "../../../../components/common/FormAction";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
import ScheduledReportsEdit from "../Components/ScheduledReportsEdit";

function ScheduledReportItemPage() {
  const [edit, setEdit] = useState(false);

  const rightBarData = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod(
        "New Scheduled Report",
        "1",
        "",
        "",
        "/reporting/scheduled-reports/new"
      ),
      RightBarMethod("Delete Scheduled Report", "1", "", "", ""),
    ]),
  ];
  return (
    <>
      <BackButton link="/" text="Back to scheduled reports" />

      <PageHeading heading="Scheduled Report" />

      <Card
        title="Title"
        bordered={false}
        extra={
          <Button
            style={{ padding: 0 }}
            onClick={() => setEdit(!edit)}
            type="link"
          >
            {edit ? "Cancel" : "Edit"}
          </Button>
        }
      >
        <Form
          name="basic"
          labelCol={{ span: 7 }}
          initialValues={{ remember: true }}
          autoComplete="off"
          className="form-container"
          colon={false}
        >
          {edit ? <ScheduledReportsEdit /> : <ScheduledView />}
        </Form>
      </Card>

      {edit ? (
        <>
          {" "}
          <br /> <FormAction />{" "}
        </>
      ) : (
        <></>
      )}

      <div className="RightSidebar">
        <RightBar RightBarData={rightBarData} />
      </div>
    </>
  );
}

export default ScheduledReportItemPage;

function ScheduledView() {
  return (
    <>
      <h4 style={{ fontSize: 13, marginBottom: 20 }}>Select Report</h4>

      <Form.Item
        label="Saved Reports"
        name="savedReports"
        wrapperCol={{ span: 14 }}
      >
        <p style={{ marginLeft: 22 }}>Copy of Unit Vacancy Detail- SS</p>
      </Form.Item>

      <Form.Item label="Format" name="format" wrapperCol={{ span: 14 }}>
        <p style={{ marginLeft: 22 }}>PDF</p>
      </Form.Item>

      <h4 style={{ fontSize: 13, marginBottom: 20 }}>Email Options</h4>

      <Form.Item label="Recipents" name="recipents" wrapperCol={{ span: 14 }}>
        <p style={{ marginLeft: 22 }}>"Aamir Ali Khan" {"<aamir@chkar.com>"}</p>
      </Form.Item>

      <Form.Item label="Bcc" name="bcc" wrapperCol={{ span: 14 }}>
        <p style={{ marginLeft: 22 }}>--</p>
      </Form.Item>

      <Form.Item label="Subject" name="subject" wrapperCol={{ span: 14 }}>
        <p style={{ marginLeft: 22 }}>Test</p>
      </Form.Item>

      <Form.Item label="Message" name="message" wrapperCol={{ span: 14 }}>
        <p style={{ marginLeft: 22 }}>Dummy Text xyz</p>
      </Form.Item>

      <h4 style={{ fontSize: 13, marginBottom: 20 }}>Schedule</h4>

      <Form.Item label="Start Date" name="startDate" wrapperCol={{ span: 14 }}>
        <p style={{ marginLeft: 22 }}>02/06/2023</p>
      </Form.Item>

      <Form.Item label="Frequency" name="frequency" wrapperCol={{ span: 14 }}>
        <p style={{ marginLeft: 22 }}>Weekly</p>

        <p style={{ fontSize: 12, marginTop: 12, marginLeft: 22 }}>
          This report will be emailed every Tuesday in the morning. The next
          email will be sent on 02/21/2023.
        </p>
      </Form.Item>
    </>
  );
}
